import { Button, Table, Tooltip } from "antd";
import moment from "moment";
import { FaPencilAlt } from "react-icons/fa";
import React from "react";
import { useNavigate } from "react-router";
import config from '../../config.json';
import auth from "../../services/authService";
import { clientFullName } from "../../utils/client";

const EditColumn = ({ contractId }) => {
    const navigate = useNavigate();

    return <Tooltip title="Editar">
        <Button
            type="primary"
            onClick={() => navigate(`/intelinet/servicios/contrato/${contractId}`)}
            icon={<FaPencilAlt />}
            shape="circle"
            disabled={!auth.isInRoles("SERVICE_UPDATE")}
        />
    </Tooltip>
}

const byStatus = config.contractStatuses.reduce((acc, { status, ...rest }) => {
  acc[status] = rest;
  return acc;
}, {});

const COLUMNS = [
    { title: "Folio servicio", dataIndex: "contractId", width: 120 },
    {
        title: "Cliente",
        render: (_, row) => clientFullName({ name: row.clientName, lastName: row.clientLastName, motherLastName: row.clientMotherLastName })
    },
    {
        title: "Domicilio",
        render: (_, row) => `${row.street} ${row.numberExternal}`
    },
    { title: "Plan", dataIndex: "productName" },
    {
        title: "Estatus",
        dataIndex: "lastStatusId",
        render: (value) => byStatus[value].text
    },
    { title: "Motivo", dataIndex: "lastStatusComments" },
    { 
        title: "Fecha alta",
        dataIndex: "lastStatusCreationDate",
        render: (value) => moment(value).format(config.dateFormat),
        width: 100
    },
    { title: "Editar", render: (_, row) => <EditColumn {...row} />, width: 100 }
];

const ServicesTable = (props) => <Table {...props} rowKey="contractId" columns={COLUMNS} />

export default ServicesTable;